import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { grey } from '@material-ui/core/colors';

export const styles = (theme: Theme) => createStyles({
	cardRoot: {
		marginBottom: theme.spacing.unit,
		cursor: 'pointer',
	},
	createDialogWrapper: {
		padding: theme.spacing.unit,
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
		textAlign: 'center',
	},
	cardImage: {
		width: '120px',
		minHeight: '120px',
		marginBottom: theme.spacing.unit * 2,
	},
	dropDownItems: {
		paddingLeft: '15px'
	},
	selectGoale: {
		paddingTop: '15px'
	},
	selectFiles: {
		paddingTop: '10px',
		color: '#42a5f5'
	},
	btnAlign: {
		marginTop: '-5px',
		float: 'right'
	},
	bodyColor: {
		backgroundColor: 'white'
	},
	headerLeft: {
		marginLeft: '-533px',
		fontSize: '20px'
	},
	selectSection: {
		width: "440px",
		paddingTop: "1px"
	},
	searchWrapper: {
		paddingTop: "15px",
		marginLeft: "12px",
		marginRight: "10px",
		position: "relative"
	},
	chaptersDiv: {
		float: "left",
		padding: "10px",
		margin: "7px",
		borderRadius: "4px",
		border: "1px solid #DFDFDF",
		"&:hover": {
			background: "#efefef"
		},
		cursor: "pointer"
	},
	'chaptersDiv:hover': {
		backgroundColor: "blue"
	},
	breadCrumbs: {
		float: "left",
		padding: "10px",
		margin: "7px",
		borderRadius: "40px",
		border: "1px solid #DFDFDF",
		backgroundColor: "#DFDFDF",
		marginTop: "19px"
	},
	paper: {
		zIndex: 1,
		width: "100%",
		maxHeight: "200px"
	},
	searchList: {
		zIndex: 9999,
		maxHeight: "250px",
		overflowY: "scroll",
		position: "absolute",
		width: "100%",
		marginTop: "-5px",
		paddingBottom: "20px"
	},formControl: {
		minWidth: 120,
		width: '95%',
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	chip: {
		margin: theme.spacing.unit / 4,
	},
	noLabel: {
		marginTop: theme.spacing.unit * 3,
	},
	author: {
		margin: '30px auto 20px',
		display: 'block',
	},
	input : {
		borderRadius: theme.shape.borderRadius,
		position: 'relative',
		backgroundColor: 'white',
		border: '1px solid #dfdfdf',
		fontSize: 16,
		minWidth: theme.spacing.unit * 3,
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:focus': {
		  borderColor: '#a1a1a1',
		}
	},
	input1: {
		borderRadius: 4,
		position: 'relative',
		backgroundColor: theme.palette.background.paper,
		border: '1px solid #ced4da',
		fontSize: 16,
		padding: '10px 26px 10px 12px',
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:focus': {
		  borderRadius: 4,
		  borderColor: '#80bdff',
		  boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
		},
	  },
	  dateIcon: {
		fill: "#a9a9a9",
		opacity: 0.8,
		marginLeft:"5px"
	  },
	  redStar:{
		  color:'red'
	  }
});